import { gql } from '@apollo/client'

export const GET_TOP_EMPTY_STORES = gql`
  query GetTopEmptyStores($filters: DashboardRankFilter!) {
    topEmptyStores(filters: $filters) {
      label
      value
      total
      rankValue
    }
  }
`
